module.exports = __webpack_public_path__ + "img/play_hover.acb3f9b7.png";